import { types } from "./types";
import { fetchCustomer } from "../../api";

export const setCustomer = customer => ({
  type: types.SET_CUSTOMER,
  payload: customer
});

export const loadCustomer = () => async dispatch => {
  const customer = await fetchCustomer();
  dispatch(setCustomer(customer));
};
